import type { ExchangeRate } from 'apis/handler/exchange-rate';
import { create } from 'zustand';
import { StorageValue, persist } from 'zustand/middleware';

export const EXCHANGE_RATE_STORE_KEY = 'exchange-rate-store';

type ExchangeRateState = {
  rates: ExchangeRate[];
  updatedAt: string;
  setRates: (rates: ExchangeRate[], updatedAt: string) => void;
};

export const useExchangeRateStore = create(
  persist<ExchangeRateState>(
    (set) => ({
      rates: [],
      updatedAt: '',
      setRates: (rates, updatedAt) => set({ rates, updatedAt }),
    }),
    {
      name: EXCHANGE_RATE_STORE_KEY,
      storage: {
        getItem: (key): StorageValue<ExchangeRateState> | null => {
          const value = localStorage.getItem(key);
          return value ? JSON.parse(value) : null;
        },
        setItem: (key, value) => {
          localStorage.setItem(key, JSON.stringify(value));
        },
        removeItem: (key) => {
          localStorage.removeItem(key);
        },
      },
    },
  ),
);
